/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SendForgotPasswordRoutingModule } from './send-forgotpassword-routing.module';
import { SendForgotPasswordComponent } from './components/send-forgotpassword.component';
import { SendForgotPasswordService } from "./services/send-forgotpassword.service";

@NgModule({
  imports: [
    CommonModule,
    SendForgotPasswordRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    TranslateModule.forChild()
  ],
  declarations: [SendForgotPasswordComponent],
  exports:[FormsModule,ReactiveFormsModule],
  providers: [SendForgotPasswordService]
})
export class SendForgotPasswordModule {
}
